<template>
  <el-form
    size="small"
    ref="formData"
    :model="formData"
    label-width="120px"
    :rules="rules"
  >
    <el-form-item align="left" label="Device list">
      <div style="display: inline">
        <el-input style="width: 60%" v-model="newDevice"></el-input>
        <el-button @click="addDevice()" class="el-button--primary"
          >add</el-button
        >
      </div>
      <div v-for="(row, index) of formData.device_list" :key="index">
        <span
          >{{ row
          }}<i
            style="color: red"
            class="el-icon-delete"
            @click="deleteDevice(index)"
          ></i
        ></span>
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "WriteDevice",
  props: {
    dialogSucc: Function,
  },
  data() {
    return {
      pre: "5423431",
      newDevice: "",
      formData: {
        admin_user_id: 0,
        device_list: [],
      },
      rules: {},
    };
  },
  created() {
    this.getDevice();
  },
  methods: {
    getDevice() {
      this.$api.rootV1.post(
        "/web/admin/writecrafiteid/getdevice",
        {},
        (res) => {
          let list = [];
          for (let i = 0; i < res.data.length; i++) {
            list.push(res.data[i].device_id);
          }
          this.formData.device_list = list;
        }
      );
    },
    deleteDevice(index) {
      this.formData.device_list.splice(index, 1);
      this.submit()
    },
    addDevice() {
      if (this.newDevice.length != 0) {
        this.formData.device_list.push(this.newDevice);
        this.newDevice = "";
        this.submit()
      }
    },
    submit() {
      if (this.newDevice.length != 0) {
        this.formData.device_list.push(this.newDevice);
        this.newDevice = "";
      }
      let params = JSON.parse(JSON.stringify(this.formData));
      let loading = this.$util.loading();
      this.$api.rootV1.post(
        "/web/admin/writecrafiteid/adddevice",
        params,
        (res) => {
          this.$alert("update completed!", "info", {
            confirmButtonText: "confirm",
            type: "success",
            callback: (action) => {
              loading.close();
            },
          });
        },
        (res) => {
          this.$alert(`Update failed!${res.errmsg}`, "info", {
            confirmButtonText: "confirm",
            type: "error",
            callback: (action) => {
              loading.close();
            },
          });
        }
      );
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/main/craftieQA/WriteDevice.vue